import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Header from '@/components/landing/Header';

const RefundPolicyPage = () => {
  return (
    <>
      <Helmet>
        <title>Refund & Cancellation Policy - Your Song Request</title>
        <meta name="description" content="Refund and cancellation policy for Your Song Request platform." />
      </Helmet>

      <div className="min-h-screen bg-gray-900 text-gray-200">
        <Header />
        
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="bg-gray-800 rounded-lg shadow-xl p-8 md:p-12">
            <h1 className="text-4xl font-bold text-white mb-8">Refund & Cancellation Policy</h1>
            
            <div className="prose prose-invert max-w-none space-y-6 text-gray-300">
              <section>
                <h2 className="text-2xl font-semibold text-white mt-8 mb-4">Our Commitment to Delivery</h2>
                <p className="leading-relaxed">
                  At Your Song Request (YSR), we utilize advanced session-management technology to ensure that audience members can only request songs when an Artist is live and capable of performing. Because our catalog is pre-vetted by the Artist, 'Item Not As Described' issues are virtually eliminated.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mt-8 mb-4">Refund Eligibility</h2>
                <p className="leading-relaxed mb-4">
                  However, we understand that live events are dynamic. You are eligible for a full refund in the following scenarios:
                </p>
                <ol className="list-decimal list-inside space-y-3 ml-4">
                  <li className="leading-relaxed">
                    <strong className="text-white">Time Constraints:</strong> If you paid for a request but the Artist's set ended before they could perform your song.
                  </li>
                  <li className="leading-relaxed">
                    <strong className="text-white">Technical Error:</strong> If a network error prevented the request from appearing on the Artist's dashboard.
                  </li>
                  <li className="leading-relaxed">
                    <strong className="text-white">Artist Cancellation:</strong> If the Artist acknowledges the request but explicitly states they cannot perform it during the current session.
                  </li>
                </ol>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mt-8 mb-4">How to Request a Refund</h2>
                <p className="leading-relaxed">
                  If your request was not fulfilled, please contact us at{' '}
                  <a 
                    href="mailto:info@yoursongrequest.com" 
                    className="text-blue-400 hover:text-blue-300 underline"
                  >
                    info@yoursongrequest.com
                  </a>
                  {' '}with your transaction details. Refunds are processed back to the original payment method within 5-10 business days.
                </p>
              </section>
            </div>

            <div className="mt-12 pt-8 border-t border-gray-700">
              <Link 
                to="/" 
                className="text-blue-400 hover:text-blue-300 underline text-sm"
              >
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="bg-black border-t border-gray-800 py-8 mt-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <p className="text-gray-400 text-sm">
                © 2026 Your Song Request. All rights reserved.
              </p>
              <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-500">
                <Link to="/refund-policy" className="hover:text-gray-400 transition-colors">
                  Refund Policy
                </Link>
                <span className="text-gray-600">•</span>
                <Link to="/terms-of-service" className="hover:text-gray-400 transition-colors">
                  Terms & Conditions
                </Link>
                <span className="text-gray-600">•</span>
                <Link to="/privacy-policy" className="hover:text-gray-400 transition-colors">
                  Privacy Policy
                </Link>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-800 text-center">
              <p className="text-xs text-gray-600">
                Registered Business Address: 6 Pendle Close, Thornton-Cleveley's, FY5 3WB
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default RefundPolicyPage;

